/**
 * API base URL for static assets (photos, files). Same source as axios (`VITE_BASE_URL`).
 * Set per environment, e.g.:
 * - .env.development: VITE_BASE_URL=http://localhost:8080/
 * - .env.production: VITE_BASE_URL=https://api.mycompany.com/
 */
export function getApiBaseUrl() {
    const base = (import.meta.env.VITE_BASE_URL ?? '').trim();
    if (!base) return '';
    return base.endsWith('/') ? base : `${base}/`;
}

/**
 * Builds a full image URL from an API-relative path or returns absolute/data URLs as-is.
 * @param {string} [path] — e.g. `/persons/photo/2` or `persons/photo/2`
 * @returns {string}
 */
export function getImageUrl(path) {
    if (path == null || path === '') return '';
    const value = String(path).trim();
    if (!value) return '';

    if (
        value.startsWith('data:')
        || value.startsWith('blob:')
        || value.startsWith('http://')
        || value.startsWith('https://')
    ) {
        return value;
    }

    const base = getApiBaseUrl();
    if (!base) {
        return value.startsWith('/') ? value : `/${value}`;
    }

    const normalizedPath = value.startsWith('/') ? value.slice(1) : value;
    return `${base}${normalizedPath}`;
}
